import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type { HelloControllerBreakMutationResponse } from "../types/HelloControllerBreak"

type HelloControllerBreakClient = typeof client<
  HelloControllerBreakMutationResponse,
  Error,
  never
>
type HelloControllerBreak = {
  data: HelloControllerBreakMutationResponse
  error: Error
  request: never
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<HelloControllerBreakClient>>
  client: {
    parameters: Partial<Parameters<HelloControllerBreakClient>[0]>
    return: Awaited<ReturnType<HelloControllerBreakClient>>
  }
}
/**
 * @link /break
 */
export function useHelloControllerBreak(
  options: {
    mutation?: UseMutationOptions<
      HelloControllerBreak["response"],
      HelloControllerBreak["error"],
      HelloControllerBreak["request"]
    >
    client?: HelloControllerBreak["client"]["parameters"]
  } = {}
): UseMutationResult<
  HelloControllerBreak["response"],
  HelloControllerBreak["error"],
  HelloControllerBreak["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    HelloControllerBreak["response"],
    HelloControllerBreak["error"],
    never
  >({
    mutationFn: async () => {
      const res = await client<
        HelloControllerBreak["data"],
        HelloControllerBreak["error"],
        HelloControllerBreak["request"]
      >({
        method: "post",
        url: `/break`,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
